query LanguagesAutocomplete($input: String = "", $value: [ID!] = []) {
  autocomplete: autocompleteLanguages(input: $input, value: $value) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
